const Introduction1 = () => {
  return (
    <div className="relative h-[800px] flex items-center bg-black-900_01 md:h-auto" id="Programs">
      {/* 배경 비디오 */}
      <video 
        autoPlay 
        loop 
        muted 
        playsInline 
        className="absolute top-0 left-0 w-full h-full object-cover opacity-50"
      >
        <source 
          src="/videos/intro-2.mp4"
          type="video/mp4" 
        />
      </video>

      {/* 컨텐츠 영역 */}
      <div className="relative z-10 py-[264px] desktop:w-[84%] h-[800px] flex items-center justify-center px-14 md:h-auto md:w-full md:px-5">
        <div className="container-xs flex flex-col items-start gap-2">
          <h2 className="font-bold text-[52px] mobile:!text-[32px] !font-monasanscodensed heading ui text-shadow-ts3">The Augmented Self</h2>
          <h3 className="!font-mdedium text-[22px] mobile:!text-[16px] heading ui leading-[31px] desktop:w-[86%] !font-monasans md:w-full">
            This year, we dive into how XR augments not just technology but our very perception of connection, growth, and the future. From AI to immersive gaming, we're bringing together top innovators to showcase how XR transforms the world.
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Introduction1;
